export default __webpack_public_path__ + "static/media/user-icon.fcf843ba.svg";